import { z } from 'zod';

import { PlatformEnvironment } from '@mews/enums';

export const appConfigurationSchema = z.object({
    nowUtc: z.string(),
    environment: z.nativeEnum(PlatformEnvironment),
    platformPrimaryUrl: z.string(),
    platformApiUrl: z.string(),
    platformUrls: z.array(z.string()),
    platformAssetUrl: z.string(),
    assetBaseUrl: z.string(),
    imageBaseUrl: z.string(),
    scriptOriginUrls: z.array(z.string()).optional(),
    applicationInsightsInstrumentationKey: z.string(),
    sentryDsn: z.string(),
    gtmContainerId: z.string().nullable(),
    pciProxyScriptUrl: z.string(),
    pciProxySecureFieldsScriptUrl: z.string(),
    launchDarklyToken: z.string(),
    launchDarklyFlagDefaultValue: z.boolean().optional(),
    launchDarklyOverrides: z
        .array(
            z.object({
                key: z.string(),
                value: z.boolean().or(z.string()).or(z.number()),
            })
        )
        .nullable(),
    gainsightToken: z.string(),
    bookingEngineGraphQLUrl: z.string().nullish(),
    cookieFirstToken: z.string(),
    newRelic: z
        .object({
            eventEndpoint: z.string().nullable(),
            logEndpoint: z.string().nullable(),
            insertKey: z.string().nullable(),
        })
        .nullish(),
    googleRecaptchaSiteKey: z.string().nullish(),
    isStandalone: z.boolean(),
});

export type AppConfiguration = z.infer<typeof appConfigurationSchema>;
